import { FC, memo, ReactNode } from 'react';
import LazyImage from '../LazyImage';

interface IProductItem {
  title: string;
  text: string;
  className?: string;
  image?: string;
  icon?: ReactNode;
  imagePosition?: {
    top?: number | string;
    left?: number | string;
    right?: number | string;
    bottom?: number | string;
    transform?: string;
    opacity?: string;
    height?: string;
    width?: number;
  };
}

const ProductItem: FC<IProductItem> = ({ text, title, className, image, imagePosition, icon }) => {
  return (
    <article className={`product_item ${className}`}>
      {image && (
        <LazyImage className='product_additional' style={{ ...imagePosition }} src={image} alt='product_detail' />
      )}
      <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {icon}
        {title}
      </h3>
      <p>{text}</p>
    </article>
  );
};

export default memo(ProductItem);
